import { render, staticRenderFns } from "./drawerVideoComp.vue?vue&type=template&id=3817cdba&scoped=true"
import script from "./drawerVideoComp.vue?vue&type=script&lang=js"
export * from "./drawerVideoComp.vue?vue&type=script&lang=js"
import style0 from "./drawerVideoComp.vue?vue&type=style&index=0&id=3817cdba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817cdba",
  null
  
)

export default component.exports